var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6668 22.75V20.5833C21.6668 19.4341 21.2103 18.3319 20.3976 17.5192C19.585 16.7065 18.4828 16.25 17.3335 16.25H8.66683C7.51756 16.25 6.41536 16.7065 5.6027 17.5192C4.79004 18.3319 4.3335 19.4341 4.3335 20.5833V22.75M17.3335 7.58333C17.3335 9.97657 15.3934 11.9167 13.0002 11.9167C10.6069 11.9167 8.66683 9.97657 8.66683 7.58333C8.66683 5.1901 10.6069 3.25 13.0002 3.25C15.3934 3.25 17.3335 5.1901 17.3335 7.58333Z",
    stroke: "#B2FC02",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGreen);
export default __webpack_public_path__ + "static/media/userGreen.8fd54d68fb4810a6540932a126ab833c.svg";
export { ForwardRef as ReactComponent };